export const DEFAULT_TAGS =  {
    'kick': 'kick',
    'hi-hat': 'hi-hat',
    'snare': 'snare',
    'clap': 'clap',
    'rim': 'rim',
    'tom': 'tom',
    'perc': 'perc',
    'breaks': 'breaks',
    'bass': 'bass',
    'sub': [['808', 'sub']],
    'keys': 'keys',
    'synth': 'Synth',
};

